import PropTypes from 'prop-types';
import React from 'react';
import humanize from 'underscore.string/humanize';

import GenericFormItem from '../GenericFormItem';

const CallbackNumber = function CallbackNumber(props) {
  const {
    val,
    label,

  } = props;
  return (
    <GenericFormItem label={label}>
      {humanize(val)}
    </GenericFormItem>
  );
};

CallbackNumber.propTypes = {
  val: PropTypes.string,
  label: PropTypes.string,
};

export default CallbackNumber;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/CallbackNumber.js